import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import config from '../config';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#303030] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src={config.assets.logos.negative}
              alt={config.company.name}
              className="h-12 w-auto"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              {config.company.description} to make your life easier. Quality, trust, and excellence in every detail.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#65C6BA]">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-300 hover:text-[#28BCB7] transition-colors">Home</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-[#28BCB7] transition-colors">Services</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-[#28BCB7] transition-colors">About Us</a></li>
              <li><a href="#testimonials" className="text-gray-300 hover:text-[#28BCB7] transition-colors">Testimonials</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#65C6BA]">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">Recurring Cleaning</li>
              <li className="text-gray-300">Deep Cleaning</li>
              <li className="text-gray-300">Move In/Out Cleaning</li>
              <li className="text-gray-300">Commercial Cleaning</li>
              <li className="text-gray-300">Post Construction</li>
              <li className="text-gray-300">Vacation Rental Cleaning</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#65C6BA]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-[#28BCB7] flex-shrink-0 mt-0.5" />
                <a href={`tel:${config.contact.phone}`} className="text-gray-300 hover:text-[#28BCB7] transition-colors">
                  {config.contact.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#28BCB7] flex-shrink-0 mt-0.5" />
                <a href={`mailto:${config.contact.email}`} className="text-gray-300 hover:text-[#28BCB7] transition-colors">
                  {config.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#28BCB7] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm leading-relaxed">
                  <p className="font-semibold text-white mb-1">Service Areas:</p>
                  {config.contact.serviceAreas.map((area, index) => (
                    <p key={index}>{area}</p>
                  ))}
                </div>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a href={config.social.facebook} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#28BCB7] transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href={config.social.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#28BCB7] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-10 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {currentYear} {config.company.name}. All rights reserved. | {config.company.description}</p>
        </div>
      </div>
    </footer>
  );
};